import React from 'react';
import { Box, Title, Text, Stack, Group, Paper } from '@mantine/core';

export const HeaderSection: React.FC = () => {
  return (
    <div className="registration-header">
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '2rem'
        }}
      >
        <Box>
          <img src="/aclue-logo.svg" alt="ACLUE Logo" className="logo" />
        </Box>
        <Title order={1} size="3rem" ta="center" style={{ marginTop: '1rem' }}>
          Ihr personalisierter KI-Newsletter
        </Title>
      </div>
      <div className="header-divider" />
      <Stack gap="md">
        <Text size="xl" ta="center" style={{ maxWidth: '800px', margin: '0 auto' }}>
          Erhalten Sie einen <strong>einmaligen, maßgeschneiderten Newsletter</strong> mit
          KI-gestützter Analyse und Personalisierung für maximale Relevanz.
          <br />
          <br />
          <strong>Dies ist ein Pilotprojekt:</strong> Basierend auf Ihrem Feedback entscheiden wir,
          ob daraus ein regelmäßiger Newsletter-Service wird. Ihre Meinung ist entscheidend für die
          Zukunft dieses Angebots.
        </Text>
        <div className="header-divider" />
        <Group gap="md" wrap="wrap" align="stretch" justify="center">
          <Paper p="md" radius="md" withBorder>
            <Stack gap={4}>
              <Text fw={600} size="lg">
                Branchenspezifisch
              </Text>
              <Text size="sm" c="dimmed">
                Newsletter für Ihre Branche
              </Text>
            </Stack>
          </Paper>
          <Text size="xl" fw={700} style={{ display: 'flex', alignItems: 'center' }}>
            &
          </Text>
          <Paper p="md" radius="md" withBorder>
            <Stack gap={4}>
              <Text fw={600} size="lg">
                Positionsspezifisch
              </Text>
              <Text size="sm" c="dimmed">
                Zugeschnitten auf Ihre Rolle
              </Text>
            </Stack>
          </Paper>
        </Group>
      </Stack>
    </div>
  );
};
